import * as React from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

const Footer = () => {
    return(
        <Container maxWidth={false} sx={{ marginTop: '1rem'}}>
            <Grid container spacing={12} sx={{display: 'relative', alignItems: 'center' }}>
                <Grid item md={4} xs={4}/>
                <Grid item md={4} xs={4}>
                    <Typography
                        sx={{
                          fontSize: { xs: '0.8rem', sm: '0.8rem' },
                          lineHeight: { xs: '0.9rem', sm: '0.9rem' },
                          textAlign: 'center'
                        }}
                    >
                    Copyright © {new Date().getFullYear()} CloudLoq
                    </Typography>
                </Grid>
                <Grid item md={4} xs={4} sx={{textAlign: 'end'}}>
                    
                </Grid>
            </Grid>
        </Container>
    );
};

export default Footer;